import FadeInRight from "./FadeInRight";

export default FadeInRight;
